export const formatMinutesAsHours = (minutes) => {
  if (!minutes && minutes !== 0) {
    return '—';
  }
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (hours > 0) {
    return `${hours}h ${mins}m`;
  }
  return `${mins}m`;
};

export const getHourTypeLabel = (slug, hourTypes) => {
  const match = hourTypes.find((type) => type.slug === slug);
  if (match?.label) {
    return match.label;
  }
  if (slug === 'unclassified') {
    return 'Unclassified';
  }
  return slug;
};

export const orderedTypeSlugs = (hourTypes, users) => {
  const slugs = hourTypes.map((type) => type.slug);
  const extras = new Set();
  users.forEach((entry) => {
    Object.keys(entry.totalsByType || {}).forEach((slug) => {
      if (!slugs.includes(slug)) {
        extras.add(slug);
      }
    });
  });
  return [...slugs, ...Array.from(extras).sort()];
};

export const sumTotals = (totalsByType) =>
  Object.values(totalsByType || {}).reduce((sum, value) => sum + value, 0);

export const getDayBreakdown = (users, selectedDay) =>
  users
    .map((entry) => {
      const day = (entry.days || []).find((row) => row.date === selectedDay);
      if (!day || sumTotals(day.totalsByType) === 0) {
        return null;
      }
      return {
        userId: entry.userId,
        name: entry.name,
        totalsByType: day.totalsByType
      };
    })
    .filter(Boolean);
